module.exports = __webpack_public_path__ + "img/体育公益_3@2x.7308b54e.png";